// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pUF5S{z-index:1400}
.mhFPb{font-size:14px;font-weight:500;border-radius:8px;-webkit-animation:jXCdc .3s ease-out;animation:jXCdc .3s ease-out}
@-webkit-keyframes jXCdc{from{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}
@keyframes jXCdc{from{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}
@media(max-width: 600px){.mhFPb{min-width:auto !important;margin:0 16px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"snackbarRoot": `pUF5S`,
	"alert": `mhFPb`,
	"slideDown": `jXCdc`
};
module.exports = ___CSS_LOADER_EXPORT___;
